import './Input.css';
import React from 'react';
import PropTypes from 'prop-types';

import { Input as AntdInput } from 'antd';

const Input = React.forwardRef(({ label, hasErrors, ...props }, ref) => {
  const input = (
    <AntdInput
      {...props}
      ref={ref}
      className={`minput ${props.className || ''} ${hasErrors ? 'error' : ''}`}
    />
  );
  if (label) {
    return (
      <label for={props.name} className="minput-label">
        {label}
        {input}
      </label>
    );
  }
  return input;
});

Input.propTypes = {
  hasErrors: PropTypes.bool,
  label: PropTypes.string,
  ...AntdInput.propTypes,
};
Input.displayName = 'Input';

export default Input;
